/**
 * Readable messages for the tenant authentication surface's machine codes
 * (TO-410 spec Contract, "Error codes"). An unmapped code falls back to the
 * API's own message, then to the error's.
 */
const MESSAGES: Record<string, string> = {
	AUTH_CONFIG_LOCKOUT:
		'That change would leave the tenant with no way to sign in. Keep password sign-in on, or verify and enable a provider first.',
	IDP_DEFAULT_INVALID: 'The default provider must be enabled and have passed a test login.',
	IDP_PROTOCOL_NOT_SUPPORTED: 'Only SAML providers have a certificate to rotate.',
	IDP_METADATA_INVALID:
		'The identity provider details are not valid. Check the SAML metadata or the OIDC issuer and endpoints and try again.',
	IDP_MAPPING_REJECTED: 'That attribute mapping is not allowed. It may only target this tenant.',
	IDP_CODE_TAKEN: 'Another provider of this tenant already uses that code.',
	IDP_LIMIT_REACHED: 'This tenant already has the maximum of 10 identity providers.',
	IDP_FIELD_IMMUTABLE: "A provider's code and protocol cannot be changed.",
	JIT_ROLE_REJECTED: 'Just-in-time users can only receive the branch user or branch admin role.',
	IDP_UNAVAILABLE: 'The identity service is unavailable. Nothing was saved; try again shortly.',
	SECRET_STORE_UNAVAILABLE: 'The secret store is unavailable. Nothing was saved; try again shortly.',
}

interface ApiErrorShape {
	response?: { data?: { error?: { code?: unknown; message?: unknown } } }
}

/** The readable message for a failed request. */
export function describeAuthenticationError(error: unknown): string {
	const apiError = (error as ApiErrorShape | null)?.response?.data?.error
	const code = typeof apiError?.code === 'string' ? apiError.code : null
	if (code && MESSAGES[code]) return MESSAGES[code]
	if (typeof apiError?.message === 'string') return apiError.message
	return error instanceof Error ? error.message : 'Something went wrong'
}
